import { Unit } from '../Class/Unit'
import { DataRef } from '../DataRef'
import { Classes, Specs } from '../types'
import { _evaluate } from './evaluate'
import { findAndReplaceUnitNodes_, getTree } from './parser'
import { isBundle, isPrimitive } from './primitive'

export function evaluateDataValue(
  value: string | DataRef,
  specs: Specs,
  classes: Classes
): DataRef<any> {
  const t = typeof value

  let ref = []
  let data: any

  if (t === 'string') {
    const tree = getTree(value as string, false, false)

    const [ref, replacedTree] = findAndReplaceUnitNodes_(tree)

    data = _evaluate(replacedTree, specs, classes)

    return { ref, data }
  } else if (t === 'object') {
    return value as DataRef
  }

  return { ref, data }
}

export function evaluateData(
  data: any,
  specs: Specs,
  classes: Classes,
  path: string[] = []
): DataRef<any> {
  let ref = []

  if (isBundle(data)) {
    ref.push([])

    data = data.__bundle

    delete data.unit.memory
  } else if (isPrimitive(data)) {
    //
  } else if (
    data.constructor.name === 'Array' ||
    data.constructor.name === 'Object'
  ) {
    const data_ = Array.isArray(data) ? [] : {}

    for (const key in data) {
      const valueRef = evaluateData(data, specs, classes, [...path, key])

      ref = ref.concat([path, ...valueRef.ref])

      data_[key] = valueRef.data

      ref.push(valueRef)
    }

    data = data_
  } else if (data instanceof Unit) {
    ref.push([])

    // @ts-ignore
    data = data.constructor.__bundle

    delete data.unit.memory
  }

  return {
    ref,
    data,
  }
}
